<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.2442 15.6123H0.5V14.9312C0.510972 13.971 0.766988 13.029 1.24245 12.1957C1.71791 11.3587 2.40184 10.6594 3.2284 10.1558C4.05497 9.65217 4.99492 9.36594 5.96046 9.31884C6.77972 9.31884 7.07596 9.40217 7.2442 9.44565M15.0966 7.32609H16.3401C16.5595 7.32609 16.7717 7.41304 16.9253 7.56522C17.0789 7.71739 17.1667 7.92754 17.1667 8.14493V16.3478C17.1667 16.5652 17.0789 16.7754 16.9253 16.9275C16.7717 17.0797 16.5595 17.1667 16.3401 17.1667H9.71659C9.49715 17.1667 9.28502 17.0797 9.13141 16.9275C8.9778 16.7754 8.89002 16.5652 8.89002 16.3478V8.14493C8.89002 7.92754 8.9778 7.71739 9.13141 7.56522C9.28502 7.41304 9.49715 7.32609 9.71659 7.32609H10.9601M10.6401 10.5H15.0966M10.6401 12.1667H12.8683H15.0966M10.6401 13.8333H12.8683H15.0966M6.22014 6.7971C7.97568 6.7971 9.3984 5.38768 9.3984 3.64855C9.3984 1.90942 7.97568 0.5 6.22014 0.5C4.4646 0.5 3.04188 1.90942 3.04188 3.64855C3.04188 5.38768 4.4646 6.7971 6.22014 6.7971ZM14.27 6.16304H11.7867C11.3295 6.16304 10.9601 6.52898 10.9601 6.98188V7.83333C10.9601 8.28623 11.3295 8.65217 11.7867 8.65217H14.27C14.7272 8.65217 15.0966 8.28623 15.0966 7.83333V6.98188C15.0966 6.52898 14.7272 6.16304 14.27 6.16304Z"
      :stroke="color"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 40,
    color: "currentColor",
  },
);
</script>
